import { isObject } from './isObject';
export var deepMap = function deepMap(obj, callBack) {
  var out = {};
  Object.keys(obj).forEach(function (key) {
    var val;
    if (isObject(obj[key])) {
      val = deepMap(obj[key], callBack);
    } else {
      val = callBack(obj[key], key);
    }
    out[key] = val;
  });
  return out;
};